goog.provide('el8.app.shared.dialog.fileReportsPrompt');

goog.require('el8.app.shared.dialog.viewInlinePdf');
goog.require('el8.template.app.shared.dialog.fileReportsPrompt');
goog.require('el8.uiwidget.NewDialog');


el8.app.shared.dialog.fileReportsPrompt = (function() {

    var yesFn = null; // the callback to run if the user says "yes"
    var noFn = null; // if user says "no"
    var patientId = null; // required in practice home

    var that = new el8.uiwidget.NewDialog({
        title: 'File Attachments as Reports in Chart',
        modal: true,
        position: 'center',
        autoHeight: true,
        width: 500
    });

    var buttonSet = new el8.uiwidget.ButtonSet();
    buttonSet.addButton('yes', 'Sign Off & File Checked Items as Reports', function() {
        if (yesFn) { yesFn(getCheckedIds()); }
        that.hide();
    }, true);
    buttonSet.addButton('cancel', 'Sign Off Letter Only', function() {
        if (noFn) { noFn(); }
        that.hide();
    });
    that.setButtonSet(buttonSet);

    var super_init = that._init;
    that._init = function() {
        super_init.call(that);

        that.getContentElt().on('click', '.view-inline-pdf',  function(e) {
            el8.app.shared.dialog.viewInlinePdf.show({
                docFileId: e.target.dataset.id*1,
                patientId: patientId
            });
            e.stopPropagation();

        }).on('click', '.attachment-checkbox',  function(e) {
            var $attachmentDiv = $(this).closest('.attachment-div');
            $attachmentDiv.toggleClass('el8BlueHighlightList');
            e.stopPropagation(); // we don't need to trigger .attachment-div after this

        }).on('click', '.attachment-div',  function(e) {
            var $this = $(this);
            $this.toggleClass('el8BlueHighlightList');
            var checkBox = $this.find('input');
            checkBox.prop('checked', !checkBox.is(':checked')); //toggle the checkbox's state
            e.stopPropagation();
        });
    };

    var super_show = that.show;
    that.show = function(spec) {
        spec = spec || {};
        yesFn = spec.yesFn;
        noFn = spec.noFn;
        patientId = spec.patientId || el8Globals.PATIENT_ID;

        super_show.call(that);
        that.setContent(
            el8.template.app.shared.dialog.fileReportsPrompt.content({
                fileables: spec.fileableAttachments,
                unfileables: spec.unfileableAttachments
            })
        );
        that.adjustHeight();
    };

    var super_hide = that.hide;
    that.hide = function() {
        super_hide.call(that);
        yesFn = null;
        noFn = null;
        patientId = null;
    };

    // get the ids of all the checked attachments
    function getCheckedIds() {
        var selected = [];
        $('.attachment-checkbox:checked').each(
            function() { selected.push($(this).data('id')); }
        );
        return selected;
    }

    return that;

})();
